<template>
  <div class="timeline">
    <div v-if="history.create" class="unit current">
      <div class="time">
        <time>{{ history.create.time | time('HH:ss') }}</time>
        <p>{{ history.create.time | time('YYYY/MM/DD') }}</p>
      </div>
      <div class="state">
        <div class="state-icon">
          <span class="material-icons md-18">
            list_alt
          </span>
        </div>
      </div>
      <div class="info">
        <h6>{{ $t('order.timeline.create') }}</h6>
      </div>
    </div>
    <div v-if="history.paid" class="unit current">
      <div class="time">
        <time>{{ history.paid.time | time('HH:ss') }}</time>
        <p>{{ history.paid.time | time('YYYY/MM/DD') }}</p>
      </div>
      <div class="state">
        <div class="state-icon">
          <span class="material-icons md-18">
            attach_money
          </span>
        </div>
      </div>
      <div class="info">
        <h6>{{ $t('order.timeline.paid') }}</h6>
        <p>{{ history.paid.payment }}</p>
      </div>
    </div>
  </div>
</template>
<script>
const getHistory = function getHistory(order) {
  const history = {
    current: 'create',
    create: { time: order.saleTime },
  };

  if (order.payment) {
    history.paid = {
      time: order.paymentTime,
      payment: order.paymentType,
    };
    history.current = 'paid';
  }

  return history;
};
const getCurrent = function getCurrent(order) {
  const history = getHistory(order);
  const current = {};

  current[history.current] = history[history.current];

  return current;
};

export default {
  props: {
    order: {
      type: Object,
    },
    currentOnly: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.currentOnly) {
      this.history = getCurrent(this.order);
    } else {
      this.history = getHistory(this.order);
    }
  },
  data() {
    return {
      history: {},
    };
  },
};
</script>

<style scoped>
.timeline .unit{ display: none;}
.timeline .unit.current{ display: inherit;}
</style>
